export default function AddSupportTicketDialogController(
  ssDialogService,
  alerts,
  loaderService,
  supportSharedModelService
) {
  const vm = this;

  vm.ticketCopy = null;
  vm.canAddTicket = true; // TODO: I'm guessing this isn't supposed to be a hard-coded value?
  vm.file = null;
  vm.selectedContact = null;

  vm.handleFileAdd = handleFileAdd;
  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSaveDialog = handleSaveDialog;
  vm.handleChangeContact = handleChangeContact;
  vm.handleChangePriority = handleChangePriority;

  _activate();

  /** ***************************************
   * Event Handlers
   */

  // eslint-disable-next-line no-unused-vars
  function handleFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.progress = 0;
  }

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSaveDialog(form) {
    if (form.$valid) {
      loaderService.showViewLoader = true;
      return _saveTicket()
        .then(() => {
          loaderService.showViewLoader = false;
          if (vm.refreshTicket) {
            vm.refreshTicket();
          }
          _closeDialog();
        })
        .catch((err) => {
          alerts.error(err);
        });
    }
    return Promise.resolve();
  }

  function handleChangeContact() {
    vm.ticketCopy.contactId = vm.selectedContact.contactId;
    vm.ticketCopy.bestContact = vm.selectedContact.fullName;
    vm.ticketCopy.contactPhone = vm.selectedContact.phone;
    vm.ticketCopy.contactEmail = vm.selectedContact.emailLower;
  }

  function handleChangePriority() {
    if (vm.ticketCopy.priorityId === -1) {
      vm.ticketCopy.priorityId = null;
    }
  }

  /** ***************************************
   * Private Functions
   */

  function _activate() {
    vm.ticketCopy = angular.copy(vm.ticket);
    vm.ticketCopy.description = ''; // While updating ticket the description field is cleared for note

    if (!vm.displayList) {
      loaderService.showViewLoader = true;
      supportSharedModelService.getDisplayLists()
        .then((displayLists) => {
          vm.displayList = displayLists;
          vm.displayListLoaded = true;
          vm.appIsLoaded = true;
          loaderService.showViewLoader = false;
        });
    }
  }

  function _saveTicket() {
    return supportSharedModelService.saveTicket(vm.ticketCopy)
      .then((ticket) => {
        alerts.success('Ticket saved successfully.');

        vm.ticketCopy.id = ticket.id;

        angular.extend(vm.ticket, vm.ticketCopy);

        if (vm.file) {
          return _uploadAttachment().then(() => {
            alerts.success('Attachment saved successfully.');
          });
        }
      });
  }

  function _uploadAttachment() {
    return supportSharedModelService.createTicketAttachment(vm.file, vm.ticketCopy.id);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.editSupportTicketDialog);
  }
}

AddSupportTicketDialogController.$inject = [
  'ssDialogService',
  'alerts',
  'loaderService',
  'supportSharedModelService'
];
